import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportComponent } from './report/report.component';
import { ReportFormComponent } from './report-form/report-form.component';
import { SharedModule } from '../../shared/shared.module';
import { BoardComponent } from './report-form/board/board.component';
import { EntityItemComponent } from './report-form/board/entity-item/entity-item.component';
import { EntityDetailComponent } from './report-form/board/entity-item/entity-detail/entity-detail.component';
import { RelationComponent } from './report-form/board/relation/relation.component';
import { DropItemComponent } from './report-form/board/relation/drop-item/drop-item.component';
import { ColumnComponent } from './report-form/board/column/column.component';
import { FilterComponent } from './report-form/board/filter/filter.component';
import { AddEntityComponent } from './report-form/board/add-entity/add-entity.component';
import { QueryComponent } from './report-form/query/query.component';
import { QueryDetailComponent } from './report-form/query/query-detail/query-detail.component';
import { RelationOptionsComponent } from './report-form/board/relation/relation-options/relation-options.component';
import { RelationZoomComponent } from './report-form/board/relation/relation-zoom/relation-zoom.component';
import { OrderChangerComponent } from './report-form/board/column/order-changer/order-changer.component';
import { ColumnEntityAliasComponent } from './report-form/board/column-entity-alias/column-entity-alias.component';
import { ThirdPartyModule } from 'src/app/modules/third-party.module';
import { ReportViewModule } from '../report-view/report-view.module';
import { FilterOptionsComponent } from './report-form/filter-options/filter-options.component';
import { ReportInfoComponent } from '../../components/report-view/report-info/report-info.component';
import { ReportMenuPreViewComponent } from './report-menu-pre-view/report-menu-pre-view.component';
import { ToolbarMenuPreViewComponent } from './report-menu-pre-view/toolbar-menu-pre-view/toolbar-menu-pre-view.component';
import { RteToolbarLiteModule, RteToolbarModule } from 'rte-library';
import { ColumnOptionsComponent } from './report-form/column-options/column-options.component';
import { ReportSaveDialogComponent } from './report-save-dialog/report-save-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    ReportComponent,
    BoardComponent,
    EntityItemComponent,
    EntityDetailComponent,
    RelationComponent,
    DropItemComponent,
    ColumnComponent,
    FilterComponent,
    AddEntityComponent,
    QueryComponent,
    QueryDetailComponent,
    RelationOptionsComponent,
    RelationZoomComponent,
    OrderChangerComponent,
    ColumnEntityAliasComponent,
    ReportFormComponent,
    FilterOptionsComponent,
    ReportInfoComponent,
    ReportMenuPreViewComponent,
    ToolbarMenuPreViewComponent,
    ColumnOptionsComponent,
    ReportSaveDialogComponent,
  ],
  exports: [
    ReportMenuPreViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule.forRoot(),
    ThirdPartyModule,
    ReportViewModule,
    RteToolbarLiteModule,
    RteToolbarModule,
    MatProgressSpinnerModule,
  ],
  entryComponents : [
    ReportSaveDialogComponent
  ]
})
export class ReportModule { }
